/**
 * Same rules as the server (backend/src/modules/auth/pin.ts), checked early for instant feedback.
 * The server remains the authority.
 */
export function pinProblem(pin: string): string | null {
  if (!/^\d{6}$/.test(pin)) return 'PIN must be exactly 6 digits';
  if (/^(\d)\1{5}$/.test(pin)) return "Don't use the same digit six times";
  const digits = [...pin].map(Number);
  const steps = digits.slice(1).map((d, i) => d - digits[i]!);
  if (steps.every((s) => s === 1) || steps.every((s) => s === -1)) {
    return "Don't use a sequence like 123456";
  }
  if (['123123', '121212', '112233', '696969', '159753'].includes(pin)) {
    return 'That PIN is too easy to guess';
  }
  return null;
}
